import { useState, useEffect } from 'react'
import { InputNumber } from 'antd'
import withRepeater from './withRepeater'

SequencedFormTimePeriod = ({ form, formItem, props... }) ->

  [loading, setLoading] = useState(true)
  [days, setDays] = useState(0)
  [hours, setHours] = useState(0)
  [minutes, setMinutes] = useState(0)

  useEffect( ->
    { days, hours, minutes } = getDaysHoursAndMinutes(props.value)
    setDays(days)
    setHours(hours)
    setMinutes(minutes)
    setLoading(false)
    undefined
  , [props.value])

  useEffect(->
    return if loading
    (-> setTimeString())()
    undefined
  , [days, hours, minutes])

  setTimeString = ->
    setLoading(true)
    timeStr = (days * 24 * 60) + (Math.min(23, hours) * 60) + Math.min(59, minutes)
    props.onChange(timeStr)
    setLoading(false)

  getDaysHoursAndMinutes = (mins = 0) ->
    days    = Math.floor(mins / 60 / 24)
    hours   = Math.floor(mins / 60 % 24)
    minutes = Math.round(mins % (24 * 60) % 60)
    { days, hours, minutes }

  <>
    <FormNumberInput
      disabled={loading}
      value={days}
      formatter={(val) -> "#{ val } days"}
      onChange={(val) -> setDays(val)}
    />
    <FormNumberInput
      disabled={loading}
      value={hours}
      max={23}
      formatter={(val) -> "#{ val } hours"}
      onChange={(val) -> setHours(val)}
    />
    <FormNumberInput
      disabled={loading}
      value={minutes}
      max={59}
      formatter={(val) -> "#{ val } minutes"}
      onChange={(val) -> setMinutes(val)}
      style={ width: 150, marginLeft: 5 }
    />
  </>

FormNumberInput = (props) ->

  parseIntegers = (str) ->
    str.replace(/[^0-9!?]/g, '').replace(/^0/g, '')

  <InputNumber
    min={0}
    value={props.value or 0}
    parser={(val) -> parseIntegers(val)}
    style={{ width: 100, props.style... }}
    { props... }
  />

export default withRepeater(
  SequencedFormTimePeriod,
  { selector: (val) -> val }
)
